import React from "react";
import { MdFileDownload, MdVisibility } from "react-icons/md";

const val = {
  invoiceUrl:
    "https://2gethrteam.s3.ap-south-1.amazonaws.com/invoice/invoice-1595513042368.pdf",
  membershipName: "Optimus Prime Research LLP",
  organisationName: "Optimus Prime Research LLP",
  TotalPayable: 59593,
  invoice_Date: "Jul 2020",
  itemDescription: "Dedicated Desk ,10Units",
};


const InvoiceListItem = ({ invoice }) => {

  const {
    invoiceUrl,
    membershipName,
    organisationName,
    TotalPayable,
    invoice_Date,
    itemDescription,
    invoiceNumber
  } = invoice;

  console.log(invoice)
  return (
    <div className="md:py-4 md:px-10 py-2 px-4 bg-white shadow-lg my-4">
      <div>
        <h4 className="text-xl leading-7">{membershipName}</h4>
      </div>
      <div>
        <div>
          <div className="mb-1">
            <p className="text-xs leading-3 text-gray-600">
              {organisationName}
            </p>
          </div>
          <div>
            <p className="text-xs leading-3 text-gray-600">{itemDescription}</p>
          </div>
        </div>
      </div>
      <h5 className="mt-3 text-base leading-5 font-medium">
          Invoice Number: {invoiceNumber}
        </h5>
      <div className="mt-1 md:flex justify-between items-center">
        <h5 className="text-base leading-5 font-medium">
          Total Payable: Rs. {TotalPayable}
        </h5>
        {/* Action Buttons */}

        <div className="flex items-center md:mt-0 mt-4 ">
          <div>
            <a href={invoiceUrl} target="_blank" rel="noopener noreferrer">
              <MdVisibility color="black" size={28} />
            </a>
          </div>
          <div className="ml-4">
            <a
              href={invoiceUrl}
              target="_blank"
              rel="noopener noreferrer"
              download
            >
              <MdFileDownload color="black" size={28} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvoiceListItem;
